import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { Url } from '@wix/da-url';
import {
  withVerification,
  WithVerificationProps,
} from '@wix/da-shared-react/pkg/VerificationPopup/withVerification';
import { GallectionType } from '../../../../../../types/gallection';
import { ShopItemType } from '../../../../../../types/shop';
import EmptyState from '../../../../EmptyState';
import camelCase from 'lodash/camelCase';

import s from '../../../EmptyState.scss';

export interface Props {
  title?: string;
  subtitle?: string;
  view?: 'large' | 'small' | 'wide';
  shopItemType?: ShopItemType;
  isOwner: boolean;
  username: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
}

export class ShopEmptyState extends React.Component<
  Props &
    WithTranslation &
    RouteComponentProps<'history'> &
    WithVerificationProps
> {
  render() {
    const {
      shopItemType,
      view,
      title,
      subtitle,
      isOwner,
      username,
      buttonLabel,
      onButtonClick,
      t,
    } = this.props;

    const shopItemTypeTranslationKey = camelCase(shopItemType || 'all');

    return (
      <EmptyState
        className={classnames(s['root'], view === 'large' && s['large'])}
        view={view}
        title={
          title ||
          (isOwner
            ? t!(
                `pages.shop.emptyState.${shopItemTypeTranslationKey}.title.owner`
              )
            : t!(
                `pages.shop.emptyState.${shopItemTypeTranslationKey}.title.visitor`,
                {
                  username,
                }
              ))
        }
        subtitle={
          subtitle ||
          (isOwner
            ? t!(
                `pages.shop.emptyState.${shopItemTypeTranslationKey}.subtitle.owner`
              )
            : t!(
                `pages.shop.emptyState.${shopItemTypeTranslationKey}.subtitle.visitor`
              ))
        }
        buttonLabel={
          buttonLabel ||
          (isOwner
            ? t!('pages.shop.emptyState.goToGallery')
            : t!('pages.shop.emptyState.messageArtist'))
        }
        onButtonClick={
          onButtonClick ||
          (isOwner ? this.navigateToGallery : this.navigateToNotes)
        }
        withButton={true}
      />
    );
  }
  navigateToGallery = () => {
    const { history, username } = this.props;
    const galleryPath = Url.userGalleryPath({
      username,
      gallectionType: GallectionType.GALLERY,
    });
    history.push(galleryPath);
  };

  navigateToNotes = () => {
    const {
      username,
      isVerificationNeeded,
      pushVerificationPopup,
    } = this.props;
    if (isVerificationNeeded) {
      pushVerificationPopup('notes');
      return;
    }

    const notesPath = Url.userNoteLink(username);
    window.location.replace(notesPath);
  };
}

export default withRouter(
  withVerification(withTranslation()(ShopEmptyState))
) as React.ComponentType<Props>;
